import { BuyerInsights } from '@fiverr-private/homepage_common_types';

export const getBuyerState = (buyerSegment?: BuyerInsights['segment']) =>
    `${buyerSegment?.buyerType}-${buyerSegment?.buyerStage}-${buyerSegment?.buyerPreference}`;
